import CurrencyYenIcon from '@mui/icons-material/CurrencyYen'
import React from 'react'
import { IconProps } from './iconBase'

/** 料金項目のアイコン */
export const MoneyIcon = (props: IconProps) => {
  return <CurrencyYenIcon {...props} />
}
